import { render, staticRenderFns } from "./LunchMenus.vue?vue&type=template&id=64b99661&scoped=true&"
import script from "./LunchMenus.vue?vue&type=script&lang=js&"
export * from "./LunchMenus.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenus.vue?vue&type=style&index=0&id=64b99661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b99661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b99661')) {
      api.createRecord('64b99661', component.options)
    } else {
      api.reload('64b99661', component.options)
    }
    module.hot.accept("./LunchMenus.vue?vue&type=template&id=64b99661&scoped=true&", function () {
      api.rerender('64b99661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/LunchMenus.vue"
export default component.exports